import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_ORGANIZER } from "graphql/query/organizer-gql";
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import OrganizerRoute from "components/routes/organizer/organizer-route";
import Localize, { localizeByKey } from "components/service/localize";


const OrganizerPage: React.FC = () => {
  useActiveMenuItem(["organizers"], ["organizers"]);

  const { id } = useParams<{ id: string }>();
  const organizerID = id ? parseInt(id) : "create";

  const { data, loading } = useQuery(GET_ORGANIZER, {
    skip: !organizerID,
    variables: {
      id: organizerID,
    },
  });


  const organizer = data?.organizer;

  const pageNavbar = [
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Overview"),
      path: "",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_ExhibitionTypes"),
      path: "exhibition-types",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_StandTypes"),
      path: "stand-types",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Equipment"),
      path: "equipment",
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Flooring"),
      path: "flooring",
    },
  ];

  const location = useLocation();

  const getPageTitle = () => {
    if (location.pathname.includes("organizers/create")) {
      return <Localize>PAGES.Title_CreateOrganizer</Localize>;
    } else if (location.pathname.includes("exhibition-types/create")) {
      return <Localize>PAGES.Title_CreateExhibition</Localize>;
    } else if (!loading && organizer) {
      return organizer?.title;
    } else {
      return "Page 404";
    }
  };


  return (
    <PageWrapDefault
      className="page-organizer"
      loading={loading}
      title={getPageTitle()}
      dataExist={organizerID === "create" ? true : !loading && organizer}
      pageNavbar={
        !loading &&
        organizer &&
        !location.pathname.includes("exhibition-types/create")
          ? pageNavbar
          : undefined
      }
      staticPath={`/organizers/${organizerID}`}
    >
      <OrganizerRoute
        organizer={organizer}
      />
    </PageWrapDefault>
  );
};

export default OrganizerPage;
